import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface Props {
  company?: { is_test_restaurant?: boolean } | null;
  className?: string;
}

/** The order pages of a partner's test restaurant say so above everything else. */
export default function TestRestaurantNotice({ company, className }: Props): JSX.Element | null {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Company:TestRestaurant' });

  if (!company?.is_test_restaurant) {
    return null;
  }

  return (
    <div
      role="status"
      data-test="test-restaurant-notice"
      className={classNames('rounded-lg border border-amber-200 bg-amber-50 p-sm text-sm text-amber-900', className)}
    >
      {t('notice')}
    </div>
  );
}
